import { schema } from 'normalizr';
import { SCHEMA_TYPE_VENDOR_AUTH_PARAMS } from '../constants/schemaTypes';

const vendorAuthParamSchema = new schema.Entity(SCHEMA_TYPE_VENDOR_AUTH_PARAMS);

export default vendorAuthParamSchema;
